import { Box, Tab, Tabs } from '@tempmee/react';
import { CandidateStatus, CandidateStatusMapper } from '~/domain/PermanentJobs';
import { Colors } from '~/themes/colors';

type TShowAbleCandidateStatus = Exclude<CandidateStatus, CandidateStatus.Cancelled>;

interface ICandidateStatusFilterPanelProps {
  counts: Record<TShowAbleCandidateStatus, number> & { all: number };
  onChange(tab: CandidateStatus | 'all'): void;
}

const MM_TABS = [CandidateStatus.Rejected, CandidateStatus.Hired] as const;

export const CandidateStatusFilterPanel = ({
  counts,
  onChange,
}: ICandidateStatusFilterPanelProps) => {
  const countInProgress =
    counts.app_expired + counts.applied + counts.interviewed + counts.new + counts.scheduled;

  return (
    <Tabs
      defaultValue="all"
      onChange={(value) => onChange(value === 'all' ? 'all' : (value as CandidateStatus))}
      style={{ alignItems: 'flex-start', gap: 16, marginBottom: 8 }}
    >
      <Tab value="all">
        <Box
          height="10px"
          width="10px"
          className="rounded-full"
          style={{ display: 'inline-block', marginRight: 6, backgroundColor: Colors.secondary_500 }}
        />
        {`In Progress${countInProgress > 0 ? ` (${countInProgress})` : ''}`}
      </Tab>
      {MM_TABS.map((it) => (
        <Tab key={it} value={it}>
          <Box
            height="10px"
            width="10px"
            className="rounded-full"
            style={{
              display: 'inline-block',
              marginRight: 6,
              backgroundColor: CandidateStatusMapper.getColor(it),
            }}
          />
          {`${CandidateStatusMapper.toHumanReadable(it)}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
        </Tab>
      ))}
    </Tabs>
  );
};
